import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Helper from "../../utils/Helper";
import PublicAPI from "../../utils/PublicAPI";

import LandingHeader from "./LandingHeader";
import LandingSessionHero from "./LandingSessionHero";
import LandingFooter from "./LandingFooter";
import { extractProductNumberFromSlug } from "../../utils/slug/session-detail";
import LandingSessionBody from "./LandingSessionBody";
import LoadingScreen from "../common/LoadingScreen";
import { sendPageViewEvent, sendPublicPageEvent } from "../../utils/TagManagerHelper";

function LandingSessionDetails() {
  const [product, setProduct] = useState([]);
  const { ID } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const productNumber = extractProductNumberFromSlug(ID);

  useEffect(() => {
    sendPageViewEvent(true);
    sendPublicPageEvent();
  }, []);

  function transformProductDetails(data) {
    return {
      id: data?.id,
      bgImage: data?.cover?.media?.url,
      title: data?.name,
      bgColor: Helper.constructBackgroundColor(data?.customFields),
      sessionSubtitle: data?.customFields?.reply_col_session_details_subtitle,
      language: Helper.transformFullLanguage(data?.customFields?.reply_col_session_language),
      duration: parseFloat(data?.customFields?.reply_col_session_duration),
      numberOfSessions: data?.customFields?.reply_col_session_meetings,
      tag: data?.tags[0]?.name,
      isDark: data?.customFields?.reply_col_session_font,
      isInsight:
        data.customFields?.reply_col_session_categories_product_type !== undefined
          ? data.customFields?.reply_col_session_categories_product_type ===
              "reply_col_session_categories_is_insights" ||
            data.customFields?.reply_col_session_categories_product_type ===
              "reply_col_session_is_dam_content"
          : false,
      isVideoLibrarySession:
        data.customFields?.reply_col_session_categories_DAM_content?.[0] ===
        "reply_col_session_categories_is_video",
      isHireATeamSession:
        data.customFields?.reply_col_session_categories_product_type === "hire_a_team",
      isArea42Labs:
        data?.customFields?.reply_col_session_categories_product_type ===
        "reply_col_session_categories_is_lab",
      productNumber: data.productNumber,
      price: Helper.formatCreditsPrice(data?.calculatedPrice?.totalPrice),
      isEvent: data?.customFields?.reply_col_session_categories_product_type === "is_event",
    };
  }

  useEffect(() => {
    PublicAPI.getSimplifiedProductDetail(productNumber)
      .then((res) => {
        let resProducts;
        if (typeof res.data === "string") {
          try {
            const data = JSON.parse(res.data);
            const [resData] = data.data;
            resProducts = resData;
          } catch (err) {
            // eslint-disable-next-line no-console
            console.error("Failed to parse response data:", err);
          }
        } else {
          const [resData] = res.data.data;
          resProducts = resData;
        }

        if (resProducts) {
          setProduct(transformProductDetails(resProducts));
        }
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      })
      .finally(() => setIsLoading(false));

    window.scrollTo(0, 0);
  }, [ID, productNumber]);

  return (
    <div className="landing-sd">
      <div className="landing-wrap">
        {isLoading ? (
          <LoadingScreen />
        ) : (
          <>
            <LandingHeader />
            <LandingSessionHero sessionData={product} />
            <LandingSessionBody />
            <LandingFooter />
          </>
        )}
      </div>
    </div>
  );
}

export default LandingSessionDetails;
